import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import routeslogo from "./assets/routeslogo.png";
import "./Navbar.css";
import { baseURL } from "./backend_url";
import axios from "axios";
import AccountPopover from "./AccountPopover";
import { formatDate_withTime } from "./commonFunctions";

function Navbar({
  setLoginSuccess,
  loginSuccess,
  newTicketCount,
  setNewTicketCount,
  allTickets,
}) {
  const [userID, setUserID] = useState("");
  const [searchedMenu, setSearchedMenu] = useState([]);
  const [search, setSearch] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [selectAll, setSelectAll] = useState(true);
  const [selectFavourites, setSelectFavourites] = useState(false);
  const [moduleDetail, setModuleDetail] = useState([]);
  const [menuItem, setMenuItem] = useState([]);
  const [userRoleDetail, setUserRoleDetail] = useState("");
  const [menuItemsFinal, setMenuItemsFinal] = useState([]);
  const [userEmail, setUserEmail] = useState("");
  const navigate = useNavigate();
  const [loggedInUser, setLoggedInUser] = useState({});
  const [showNotifications, setShowNotifications] = useState(false);
  const notificationRef = useRef(null);

  useEffect(() => {
    axios.get(baseURL + "/get_srt_modules").then((res) => {
      const menuItems = res.data.map((val1) => {
        let temp_mod_name1 = val1.name.toString().trim();
        if (temp_mod_name1.indexOf(" ") > -1) {
          let t1_split = temp_mod_name1.split(" ");
          if (t1_split.length > 0) {
            temp_mod_name1 = "";
            for (let i1 = 0; i1 < t1_split.length; i1++) {
              temp_mod_name1 += t1_split[i1];
            }
          }
        }
        return {
          name: val1.name,
          routing: "/Shuttle_Tracking/" + temp_mod_name1,
          favourite: val1.favourite,
        };
      });

      setModuleDetail(res.data);
      const loggedInUser = sessionStorage.getItem("user_token");
      const foundUser = JSON.parse(loggedInUser);
      setLoggedInUser(foundUser);
      setUserEmail(foundUser?.userEmail);
      setUserID(foundUser?.userID);

      if (
        foundUser?.role === "Users" ||
        (foundUser?.role === "SuperAdmin" &&
          foundUser?.role2 !== undefined &&
          foundUser?.role2 === "Admin")
      ) {
        axios
          .post(baseURL + "/get_srt_individual_user_details", {
            user_email: foundUser.userEmail,
          })
          .then((res1) => {
            let accnt = foundUser.account_id;
            axios
              .post(baseURL + "/get_srt_user_role_detail_db", {
                user_role: res1.data[0].selected_role,
                account_id: accnt.toString(),
              })
              .then((res2) => {
                const tempMenuItems = menuItems.filter((val) => {
                  let temp_mod_name = val.name.toString().trim();
                  if (temp_mod_name.indexOf(" ") > -1) {
                    let t1_split = temp_mod_name.split(" ");
                    if (t1_split.length > 0) {
                      temp_mod_name = "";
                      for (let i1 = 0; i1 < t1_split.length; i1++) {
                        temp_mod_name += t1_split[i1];
                      }
                    }
                  }
                  if (
                    res2.data[0].role_definition[
                      temp_mod_name + "_Access Specifier"
                    ] === "Edit" ||
                    res2.data[0].role_definition[
                      temp_mod_name + "_Access Specifier"
                    ] === "View"
                  ) {
                    return val;
                  }
                });
                setMenuItemsFinal(tempMenuItems);
              });
          });
      } else if (foundUser?.role === "SuperAdmin") {
        const tempMenuItems = menuItems;
        setMenuItemsFinal(tempMenuItems);
      }
      let arr2 = [];
      res.data.map(() => {
        arr2.push(false);
      });
      setMenuItem(arr2);
    });
  }, []);

  const handleLogout = () => {
    setLoginSuccess(false);
    navigate("/Shuttle_Tracking/", { replace: true });
    sessionStorage.clear();
    window.location.reload();
  };

  const handleNotificationClick = (e) => {
    e.stopPropagation();
    setNewTicketCount(0);
    setShowNotifications(!showNotifications);
  };

  const handleNotificationItemClick = (ticketId) => {
    navigate("/Shuttle_Tracking/RequestVehicle", { state: { ticketId } });
    setShowNotifications(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-custom-primary">
      <div className="container-fluid">
        <a className="navbar-brand" href="/Shuttle_Tracking/">
          <img src={routeslogo} alt="Route's logo" className="navbar-logo" />
        </a>
        <NavLink
          className="navbar-brand ms-2 title-link"
          to="/Shuttle_Tracking/"
        >
          Shuttle Request & Tracking
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarNav"
        >
          <ul className="navbar-nav">
            {loggedInUser.role === "Users" && (
              <li className="nav-item dropdown" ref={notificationRef}>
                <div
                  className="notification-icon"
                  role="button"
                  onClick={handleNotificationClick}
                  style={{ position: "relative", marginRight: "10px" }}
                >
                  <span
                    style={{ fontSize: "24px", transition: "transform 0.2s" }}
                  >
                    🔔
                  </span>
                  {newTicketCount > 0 && (
                    <span
                      className="notification-count"
                      style={{
                        position: "absolute",
                        top: "-5px",
                        right: "0",
                        marginRight: "-7px",
                        backgroundColor: "red",
                        color: "white",
                        borderRadius: "50%",
                        padding: "2px 6px",
                        fontSize: "12px",
                        animation: "pulse 1s infinite",
                      }}
                    >
                      {newTicketCount}
                    </span>
                  )}
                </div>
                {showNotifications && (
                  <ul className="dropdown-menu show" style={{ 
                    right: 0, 
                    left: 'auto', 
                    maxHeight: '400px', 
                    overflowY: 'auto',
                    backgroundColor: 'white',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    padding: '10px',
                    width: '400px',
                    scrollbarWidth: 'thin', // Added to make scroll thumb thin
                    '-ms-overflow-style': 'none' // Added to make scroll thumb thin for Edge and Internet Explorer
                  }}>
                    {allTickets.filter(ticket => ticket.ticket_status).length > 0 ? (
                      allTickets.filter(ticket => ticket.ticket_status).map((ticket) => (
                        <li key={ticket._id} style={{
                          borderBottom: '1px solid #eee',
                          padding: '10px 0',
                          cursor: 'pointer',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          margin: '5px 0',
                          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
                        }}>
                          <div
                            onClick={() => handleNotificationItemClick(ticket._id)}
                            style={{ color: 'black', padding: '10px' }}
                          >
                            <strong>Customer: </strong>{ticket.customer_name}<br />
                            <strong>Reservation No.: </strong>{ticket.reservationNumber}<br />
                            <strong>Location: </strong>{ticket.locationId.split("-")[1]}<br />
                            <strong>Terminal: </strong>{ticket.selectedTerminal}<br />
                            <strong>Pillar: </strong>{ticket.selectedPillar}<br />
                            <strong>Requested on: </strong>{formatDate_withTime(new Date(ticket.requested_date))}
                          </div>
                        </li>
                      ))
                    ) : (
                      <li><div style={{ color: 'black', padding: '10px' }}>No new notifications</div></li>
                    )}
                  </ul>
                )}
              </li>
            )}
            {menuItemsFinal.slice(0, 5).map((val, index) => (
              <li className="nav-item" key={index}>
                <NavLink
                  exact
                  className="nav-link"
                  activeClassName="active-link"
                  to={val.routing}
                >
                  {val.name}
                </NavLink>
              </li>
            ))}
            {menuItemsFinal.length > 5 && (
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  More
                </a>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  {menuItemsFinal.slice(5).map((val, index) => (
                    <li key={index}>
                      <NavLink
                        exact
                        className="dropdown-item"
                        activeClassName="active-link"
                        to={val.routing}
                      >
                        {val.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </li>
            )}

            {loginSuccess && (
              <li className="nav-item" style={{ padding: "5px" }}>
                <AccountPopover setLoginSuccess={setLoginSuccess} />
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
